import { forwardRef, Switch, SwitchProps } from '@chakra-ui/react';
import { ChangeEvent } from 'react';

interface YesNoSelectProps extends Omit<SwitchProps, 'value' | 'onChange'> {
    value: boolean;
    onChange: (value: boolean) => void;
}
const YesNoSelectInner = (
    { value, onChange, ...props }: YesNoSelectProps,
    ref: React.ForwardedRef<HTMLInputElement>
) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange?.(event.target.checked);
    };
    return (
        <Switch
            ref={ref}
            isChecked={value}
            variant="yesNo"
            onChange={handleChange}
            {...props}
        />
    );
};

const YesNoSelect = forwardRef<YesNoSelectProps, 'switch'>(YesNoSelectInner);

export default YesNoSelect;
